import { useContext } from 'react';

import { UpcomingCalendarViewOptionsContext } from './context';

export const useUpcomingCalendarViewOptions = () =>
  useContext(UpcomingCalendarViewOptionsContext);
